import React from 'react'

export const ChartLineVertical = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
    {...props}
  >
    <path
      d='M13.5 3C14.5544 3 15.4182 3.81588 15.4945 4.85074L15.5 5V21H9.5V5C9.5 3.94564 10.3159 3.08183 11.3507 3.00549L11.5 3H13.5ZM20.5 8C21.6046 8 22.5 8.89543 22.5 10V19C22.5 20.1046 21.6046 21 20.5 21H17.5V8H20.5ZM7.5 11V21H4.5C3.39543 21 2.5 20.1046 2.5 19V13C2.5 11.8954 3.39543 11 4.5 11H7.5Z'
    />
  </svg>
)
